import PriceContainer from "components/PriceContainer";
import React from "react";
import {
  eventsMarks,
  messagesMarks,
  storageMarks,
  storiesMarks,
} from "./marks";
import Growth from "components/BundleContainer/Growth";
import Starter from "components/BundleContainer/Starter";

type Props = {};

function Pricing({}: Props) {
  return (
    <div className="my-2">
      <h1 className="text-center mt-2">Bundles</h1>
      <p className="text-center text-white mb-2">
        {" "}
        We've Simplified it for You!
      </p>
      <div className="prices_wrapper">
        <Starter />
        <Growth />
      </div>
      <h1 className="text-center my-2">Content Distribution</h1>
      <div className="prices_wrapper">
        <PriceContainer
          title="Videofied Search"
          description="Create engaging video content to enhance websites, improving user experience and potentially increasing visitor engagement and retention on the site."
          value={10}
          marks={storageMarks}
          defaultValue={100}
          descriptions={[
            [
              "Videofied Search Integration",
              "Up to 5 GB Storage",
              "Monthly Search Analytics",
              "Priority Customer Support",
            ],
            [
              "Videofied Search Integration",
              "Up to 10 GB Storage",
              "Monthly Search Analytics",
              "Priority Customer Support",
            ],
            [
              "Videofied Search Integration",
              "Up to 50 GB Storage",
              "Monthly Search Analytics",
              "Priority Customer Support",
            ],
            [
              "Videofied Search Integration",
              "Up to 100 GB Storage",
              "Monthly Search Analytics",
              "Priority Customer Support",
            ],
          ]}
        />
        <PriceContainer
          title="Videofied Newsletters"
          description="Personalized video newsletters keep customers engaged by delivering tailored news in an engaging format, fostering a connection and enhancing communication between the business and its audience."
          value={1}
          marks={storiesMarks}
          defaultValue={24}
          descriptions={[
            [
              "4 Credits/month (1 Video Newsletter)",
              "Premium AI Avatar Integration",
              "Priority Customer Support",
              "Advanced Analytics",
            ],
            [
              "24 Credits/month (6 Video Newsletters)",
              "Premium AI Avatar Integration ",
              "Priority Customer Support",
              "Advanced Analytics",
            ],
            [
              "72 Credits/month (18 Video Newsletters)",
              "Premium AI Avatar Integration",
              "Priority Customer Support",
              "Advanced Analytics",
            ],
            [
              "100 Credits/month (25 Video Newsletters)",
              "Premium AI Avatar Integration",
              "Priority Customer Support",
              "Advanced Analytics",
            ],
          ]}
        />
        <PriceContainer
          title="Events & Calendar"
          description="Organizes and manages events through a convenient calendar system."
          value={1}
          marks={eventsMarks}
          defaultValue={35}
          removeSlider={true}
          descriptions={[
            [
              "Streamline your brand's event management with our comprehensive monthly subscription. Ideal for businesses of all sizes, and ensuring coordination of events, appointments, and important dates within your organization.",
            ],
            [
              "Streamline your brand's event management with our comprehensive monthly subscription. Ideal for businesses of all sizes, and ensuring coordination of events, appointments, and important dates within your organization.",
            ],
            [
              "Streamline your brand's event management with our comprehensive monthly subscription. Ideal for businesses of all sizes, and ensuring coordination of events, appointments, and important dates within your organization.",
            ],
          ]}
        />
        <PriceContainer
          title="Inbound Marketing"
          description="Attracts customers through video content campaigns via SMS, Email, Whatsapp etc."
          value={0.03}
          marks={messagesMarks}
          defaultValue={30}
          descriptions={[
            [
              "Our inbound marketing services includes email, sms and whatsapp marketing for various campaigns targeted for a small-scale engagement",
            ],
            [
              "Our inbound marketing services includes email, sms and whatsapp marketing for various campaigns targeted for an Increased capacity for growing interactions",
            ],
            [
              "Our inbound marketing services includes email, sms and whatsapp marketing for various campaigns targeted for moderate inbound marketing campaigns",
            ],
            [
              "Our inbound marketing services includes email, sms and whatsapp marketing for various campaigns targeted for a High-capacity plan for extensive campaigns",
            ],
          ]}
        />
      </div>
      <h1 className="text-center my-2">Content Creation</h1>
      <div className="prices_wrapper">
        <PriceContainer
          title="cBee.ai"
          description="A suite of tools to create stunning content to boost your business sales growth."
          value={1}
          marks={storiesMarks}
          defaultValue={24}
          descriptions={[
            [
              "4 Credits (1 Video)",
              "Full access to CBee.ai suite",
              "Advanced video creation features",
              "Priority customer support",
            ],
            [
              "Full access to CBee.ai suite",
              "Advanced video creation features",
              "Priority customer support",
              "24 Credits",
            ],
            [
              "Full access to CBee.ai suite",
              "Advanced video creation features",
              "Priority customer support",
              "72 Credits",
            ],
            [
              "Full access to CBee.ai suite",
              "Advanced video creation features",
              "Priority customer support",
              "100 Credits",
            ],
          ]}
        />
      </div>
      <h1 className="text-center my-2">Customer Engagement</h1>
      <div className="prices_wrapper">
        <PriceContainer
          title="Multilingual Chatbot"
          description="Communicates seamlessly in multiple languages for global user interaction."
          value={0.03}
          marks={messagesMarks}
          defaultValue={30}
          descriptions={[
            ["Ideal for small-scale engagement"],
            ["Increased capacity for growing interactions"],
            ["Suitable for moderate chatbot interactions"],
            ["High-capacity plan for extensive interactions"],
          ]}
        />
        <PriceContainer
          title="Video-based SEO"
          description="Unleash the power of video-based SEO to amplify your website's search engine visibility and attract a surge of organic traffic."
          value={10}
          marks={storageMarks}
          defaultValue={100}
          descriptions={[
            [
              "On-page optimization",
              "Basic keyword research",
              "Structured analytics reports",
              "5GB storage",
            ],
            [
              "Full on-page optimization",
              "Basic off-page optimization",
              "Advanced keyword research",
              "Structured analytics reports",
              "10GB storage",
            ],
            [
              "Full on-page and off-page optimization",
              "Comprehensive keyword research",
              "Structured analytics reports",
              "50GB storage",
            ],
            [
              "Full on-page and off-page optimization",
              "Advanced keyword research",
              "Structured analytics reports",
              "Personalized SEO strategy sessions",
              "100GB storage",
            ],
          ]}
        />
        <PriceContainer
          title="Hive Link"
          description="1-1/Group online interactions among all community members."
          value={10}
          marks={storageMarks}
          defaultValue={100}
          descriptions={[
            ["Suitable for small-scale streaming"],
            ["Increased storage for growing needs"],
            ["Ideal for moderate streaming requirements"],
            ["High-capacity plan for extensive streaming"],
          ]}
        />
        {/* <PriceContainer
          title="Mobile App Plugin"
          description="Elevate your brand's mobile experience with a user friendly App or get our plugin into your App."
          value={10}
          marks={storageMarks}
          defaultValue={100}
          descriptions={[
            ["Suitable for small-scale streaming"],
            ["Increased storage for growing needs"],
            ["Ideal for moderate streaming requirements"],
            ["High-capacity plan for extensive streaming"],
          ]}
        /> */}
      </div>
    </div>
  );
}

export default Pricing;
